module.exports = __webpack_public_path__ + "87a5c54270d26ec4568dad1d9dcdec42.jpg";